import React from 'react';
import { useTranslate } from '@bynder/localization';
import { SearchItem, SearchMetaproperty, SearchResults } from '../../../../types';
import GroupMetapropertiesOptions from './GroupOptions';
import { calculateHeightStyle } from '../calculateHeightStyle';

interface Props {
	searchTerm: string;
	metaproperty: SearchMetaproperty;
	defaultSearchAction: (isMPOSearch?: boolean, metapropertyName?: string) => void;
	clearSearchTerm: () => void;
	results: SearchResults;
	currentActiveSearchItem: SearchItem | undefined;
}

export function GroupMetaproperties({
	searchTerm,
	metaproperty,
	defaultSearchAction,
	clearSearchTerm,
	results,
	currentActiveSearchItem,
}: Props) {
	const { translate } = useTranslate();

	const onMetapropertyClick = (e: React.MouseEvent) => {
		e.preventDefault();

		if (metaproperty.spotlightFilterAction === 'pim') {
			document.location.href = `/show/${metaproperty.name}/`;
		}
	};
	const title = translate('spotlight.showMetaPropertyResults', {
		'1': metaproperty.label,
		'2': searchTerm,
	});

	return (
		<>
			<li className="meta-property-overview" onClick={onMetapropertyClick}>
				<a
					href="#"
					className={
						metaproperty.spotlightFilterAction === 'pim' ? 'header' : 'header no-click'
					}
				>
					{title}
				</a>
			</li>
			<div className="spotlight-results" style={calculateHeightStyle(results)}>
				<ul
					className="spotlight-meta-metaproperty"
					data-filter-action={metaproperty.spotlightFilterAction}
					data-name={metaproperty.name}
				>
					{/* <cfif metaproperty.orderBy == "label">
					    <cfset orderBy = "label" />
					    <cfset sortType = "textnocase" />
					<cfelse>
					    <cfset orderBy = "zindex" />
					    <cfset sortType = "numeric" />
					</cfif> */}

					{metaproperty.options &&
						metaproperty.options.length > 0 &&
						metaproperty.options
							.sort()
							.map((option) => (
								<GroupMetapropertiesOptions
									defaultSearchAction={defaultSearchAction}
									metapropertyOption={option}
									metapropertyName={metaproperty.name}
									spotlightFilterAction={metaproperty.spotlightFilterAction}
									clearSearchTerm={clearSearchTerm}
									key={option.id}
									isActive={currentActiveSearchItem?.id === option.id}
								/>
							))}
				</ul>
			</div>
		</>
	);
}
